
<div >
 <div class="label-bar">
     <label i18n="@@spmsUserReg" class="textColour" style="font-size: 18px;
    font-weight: 500;">Alert Library</label>
     <span class="example-spacer"></span>
       <app-common-button
          title="Refresh"
          icon="fas fa-sync-alt"
          [variant]="'cancel'"
          [buttonId]="1111"
          [critical]="false"
          width="100%"
          padding="0rem 1rem"
          fontSize=".85rem"
          height="25px"
          (clicked)="onRefresh()"
           style="margin-left: 6px;margin-right:6px;"
          >
          </app-common-button>
        <app-common-button
           title="Download"
          icon="fas fa-download"
          [buttonId]="1111"
          [variant]="'cancel'"
           width="100%"
          padding="0rem 1rem"
          fontSize=".85rem"
          height="25px"
          [critical]="false"
          (clicked)="onDownload()"
           style="margin-left: 6px;margin-right:6px;"
          >
          </app-common-button>
     <app-common-button 
          label="Add Record" 
          title="Add Record "
          icon="fas fa-plus-circle"
           height="25px"
          [buttonId]="1111"
          [critical]="true"
          (clicked)="onCreate()"
           style="margin-left: 6px;margin-right:6px;"
          >
          </app-common-button>
          
  </div>
    <div style="margin-top: 1.5%;">
        <div>

<!-- <ag-grid-angular
    class="ag-theme-balham"

    style="width: 100%;height: 500px;"
    [rowData]="alertsData"
    [defaultColDef]="defaultColDef"
    [columnDefs]="columnDefs"
    [gridOptions]="gridOptions"
    [pagination]="true"
    [paginationPageSize]="10"
    [enableBrowserTooltips]="true"
    (gridReady)="onGridReady($event)"
    [components]="components"
    [rowClassRules]="rowClassRules"
    [getRowStyle]="getRowStyle"
  >
  </ag-grid-angular> -->
  <ag-grid-angular
      style="margin-top: 2%;height: 55vh;"
      class="ag-theme-balham"
      [rowData]="alertsData"
      [components]="components"
      [columnDefs]="columnDefs"
      [defaultColDef]="defaultColDef"
      [animateRows]="true"
        [gridOptions]="gridOptions"
    [paginationPageSize]="10"
      (gridReady)="onGridReady($event)"
      [enableBrowserTooltips]="true"
      [pagination]="true">
    </ag-grid-angular>


        </div>

    </div>
</div>

